// garuda - Jackpot Word Component

import React from "react";
import { triggerJackpotAnimation } from "../utils/helpers";

const JackpotWord = ({ children, className = "", onClick }) => {
  return (
    <span
      className={`jackpot-word ${className}`}
      data-original={children}
      onMouseEnter={(e) => triggerJackpotAnimation(e.target)}
      onClick={onClick}
      style={{ cursor: "pointer", display: "inline-block" }}
    >
      {children}
    </span>
  );
};

export default JackpotWord;
